import { styled } from '@mui/material'
import { Arrow as ArrowIcon } from '@/icons'

export const Arrow = styled(ArrowIcon, { name: 'Arrow' })({
  transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'absolute',
  opacity: 0,
  right: 0,
})
